var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290.01,
    height: 100,
    viewBox: "0 0 290.01 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient30",
    x2: 1,
    gradientTransform: "matrix(-7e-6 -164.3 -164.3 7e-6 636.24 170.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,0.75)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,0.75)",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient56",
    x2: 1,
    gradientTransform: "matrix(161.08 -129.36 -129.36 -161.08 380.05 153.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,0.75)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,0.75)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m248.83 206.33 139.83-63.093-63.094-143.23-139.83 63.089 63.094 143.24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient84",
    x2: 1,
    gradientTransform: "matrix(-6e-6 -143.94 -143.94 6e-6 287.19 149.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,0.75)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,0.75)",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient110",
    x2: 1,
    gradientTransform: "matrix(24.754 -149.44 -149.44 -24.754 78.386 163.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,0.75)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,0.75)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 100.08)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.29378 0 0 .29378 0 .042373)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(740.38 200.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-175.61l-24.248-23.659v171.73l24.248 27.54",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m716.52 173.3h-160.57v-171.94h160.57z",
    fill: "url(#linearGradient30)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(581.1 200.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-25.151-27.424h160.57l23.857 27.54-159.28-0.116",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.23 193.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 157.946,21.956 144.731,-15.916 -4.901,-39.646 -4.264,-12.575 0,0",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m526.96 177.28 21.881-154.04-155.74-21.883-21.03 148.92 9.094 7.106 145.8 19.893",
    fill: "url(#linearGradient56)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(540.18 215.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 0.122-0.93 20.484-157.73-11.94-33.25-21.881 154.04",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 255.36h740.38v-255.3h-740.38z",
    fill: "url(#linearGradient84)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.31 255.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 14.515,-49.028 154.343,-112.121 142.588,-65.273 0,0",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.31 255.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -56.279,-133.569 7.7,-58.697 L 14.515,-49.028 0,0",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m156.3 177.5 23.047-151.58-154.53-24.23-24.82 151.87 156.3 23.932",
    fill: "url(#linearGradient110)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 153.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 10.852,54.119 166.879,79.129 156.304,23.932 0,0",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.88 232.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 22.877,-153.042 12.472,-206.773 -10.575,-55.197 0,0",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(500.47 147.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.703 4.784-2.337 8.434-4.985 10.825-2.105 1.91-4.753 2.875-7.771 2.87-0.77 0-1.563-0.062-2.386-0.182-4.043-0.581-7.14-2.454-9.038-5.546-1.38-2.234-2.05-4.929-2.05-8.029 0-1.187 0.099-2.438 0.293-3.75l5.681-40.081-44.78-6.59-5.681 40.089c-0.687 4.66-2.298 8.273-4.91 10.729-2.109 1.991-4.739 3.009-7.705 3.002-0.7 0-1.419-0.056-2.153-0.164-4.215-0.607-7.425-2.445-9.374-5.491-1.414-2.194-2.096-4.902-2.096-8.051 0-1.209 0.103-2.487 0.298-3.835l15.322-104.24c0.703-4.793 2.38-8.435 5.135-10.789 2.149-1.839 4.843-2.764 7.929-2.758 0.843 0 1.72 0.066 2.625 0.2 3.855 0.558 6.833 2.423 8.629 5.511 1.287 2.195 1.913 4.832 1.913 7.85 0 1.208-0.099 2.474-0.295 3.8l-6.261 41.184 44.778 6.581 6.265-41.183c0.689-4.73 2.349-8.351 5.066-10.736 2.158-1.898 4.826-2.853 7.85-2.848 0.777 0 1.573 0.059 2.395 0.18 4.028 0.586 7.113 2.431 8.955 5.498 1.327 2.188 1.967 4.841 1.967 7.899 0 1.21-0.097 2.483-0.293 3.82zm-182.12-57.657c-5.269-12.41-12.224-20.924-20.83-25.641-4.612-2.527-9.338-3.777-14.227-3.779-4.248 0-8.627 0.949-13.149 2.863-9.786 4.172-15.882 10.877-18.521 20.334-0.882 3.173-1.326 6.508-1.326 10.013 0 6.941 1.742 14.556 5.256 22.841 5.388 12.704 12.421 21.371 21.034 26.117 4.599 2.535 9.329 3.794 14.234 3.794 4.295 0 8.733-0.961 13.33-2.912 9.724-4.137 15.759-10.857 18.35-20.357 0.842-3.106 1.266-6.375 1.266-9.817 0-7.088-1.791-14.909-5.417-23.456zm15.318 62.394c-5.494 5.794-12.167 10.351-19.993 13.67-7.768 3.3-15.622 4.946-23.537 4.946l-0.365-2e-3c-8.037-0.052-15.98-1.841-23.809-5.353v3e-3c-8.195-3.567-15.337-8.558-21.396-14.968-6.06-6.406-10.995-14.112-14.805-23.088-3.758-8.872-5.844-17.747-6.231-26.624-0.045-1.004-0.066-2.009-0.066-3.01 0-7.834 1.343-15.509 4.027-23.008 2.848-7.916 7.047-14.769 12.584-20.545 5.535-5.776 12.344-10.373 20.401-13.782v2e-3c7.706-3.274 15.531-4.912 23.457-4.908h0.203c7.994 0.037 15.922 1.75 23.76 5.117l7e-3 3e-3 5e-3 3e-3c8.245 3.679 15.436 8.737 21.568 15.139 6.129 6.408 11.084 14.092 14.872 23.017 3.787 8.924 5.85 17.809 6.189 26.647 0.032 0.852 0.048 1.702 0.048 2.55 0 7.947-1.404 15.734-4.214 23.352-2.974 8.094-7.214 15.047-12.705 20.839zm-193.97-102.44c-1.218 1.455-2.858 2.53-4.856 3.229-2.055 0.717-4.538 1.062-7.463 1.062-2.756 0-5.906-0.307-9.46-0.916l-40.787-6.971c0.431 3.143 1.992 7.274 4.744 12.308 3.074 5.64 7.605 12.414 13.591 20.3l3e-3 4e-3c2.054 2.745 3.624 4.842 4.709 6.29 0.779 0.965 1.864 2.384 3.27 4.26 9.33 12.24 15.105 22.206 17.319 30.028 1.267 4.435 2.038 8.904 2.317 13.405 0.076 1.232 0.111 2.455 0.111 3.669 0 3.225-0.264 6.401-0.798 9.526-0.486 2.848-1.187 5.217-2.127 7.118-0.94 1.897-2.133 3.34-3.606 4.25-1.661 1.011-3.998 1.44-7.055 1.445-2.524 0-5.551-0.306-9.094-0.91l-47.135-8.065c-5.708-0.978-9.923-2.658-12.612-5.19-2.137-2.005-3.241-4.602-3.23-7.583 0-0.778 0.071-1.583 0.215-2.416 0.663-4.005 2.75-6.942 6.115-8.436 1.986-0.896 4.386-1.324 7.187-1.324 1.908 0 4.004 0.199 6.294 0.589l39.451 6.653c0.067-0.697 0.113-1.393 0.113-2.083 0-2.465-0.427-4.872-1.282-7.242-1.171-3.265-4.097-7.933-8.76-13.867-1.321-1.62-3.345-4.144-6.072-7.564-10.639-12.888-18.259-23.876-22.87-33.016 0-4e-3 0-4e-3 -3e-3 -8e-3 0 0 0-4e-3 -1e-3 -4e-3 -3.273-6.291-5.545-12.488-6.791-18.588-0.726-3.558-1.093-6.974-1.093-10.252 0-2.347 0.188-4.619 0.565-6.818 0.54-3.155 1.319-5.758 2.368-7.82 1.049-2.053 2.387-3.588 4.039-4.496 1.538-0.834 3.798-1.165 6.909-1.174 3.949 0 9.265 0.582 15.994 1.73l42.768 7.313c7.574 1.303 12.841 3.109 15.902 5.623 2.446 2.009 3.713 4.767 3.7 8.016 0 0.822-0.076 1.671-0.229 2.554-0.359 2.109-1.142 3.918-2.36 5.371zm-36.248 39.569 3e-3 2e-3c-3e-3 -2e-3 -3e-3 -4e-3 -4e-3 -5e-3h-3e-3zm555.56-34.842c-6.152-7.435-14.437-11.125-25.131-11.137-10.767 0.012-19.086 3.69-25.272 11.087-6.168 7.403-9.29 17.581-9.294 30.645 4e-3 13.313 3.114 23.643 9.249 31.104 6.15 7.458 14.493 11.161 25.317 11.175 10.694-0.014 18.976-3.714 25.131-11.175 6.139-7.461 9.254-17.791 9.254-31.104 0-13.003-3.108-23.17-9.254-30.595zm33.001 56.66c-3.178 7.984-7.882 15.142-14.102 21.458-5.954 6.071-12.647 10.653-20.035 13.728-7.398 3.077-15.394 4.613-23.983 4.611-8.648 2e-3 -16.723-1.533-24.176-4.609-7.452-3.076-14.14-7.661-20.037-13.733-6.211-6.253-10.896-13.386-14.007-21.367-3.109-7.989-4.667-16.701-4.667-26.127 0-9.304 1.562-17.987 4.717-26.027 3.14-8.042 7.8-15.262 13.957-21.637 5.771-5.962 12.389-10.473 19.808-13.516 7.423-3.04 15.568-4.562 24.405-4.562 8.52 0 16.508 1.522 23.927 4.562 7.423 3.041 14.13 7.549 20.087 13.508 6.224 6.381 10.928 13.579 14.106 21.596 3.18 8.009 4.769 16.71 4.769 26.076s-1.589 18.052-4.769 26.039",
    fill: "#020617"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient01);
export default __webpack_public_path__ + "static/media/client-01.f04ee6bb36a8226a447fcf691452c083.svg";
export { ForwardRef as ReactComponent };